import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=1592163f"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports